import "./VorTable.css";

import { useDispatch, useSelector } from "react-redux";

import Table from "components/Table/Table";
import { getVorTableData } from "slices/vor/vorSelectors";
import { vorActions } from "slices/vor/vorSlice";

import VorTableColumns from "./VorTableColumns";

const VorTable = ({ scrollBlock, upperFuncs }) => {
	const dispatch = useDispatch();
	const tableData = useSelector(getVorTableData);
	const columnsData = VorTableColumns({ upperFuncs });

	return (
		<div className="VorTable">
			<Table
				rowData={tableData}
				columnsData={columnsData}
				scrollBlock={scrollBlock}
				options={{
					selectOptions: {
						controlled: true,
						uncontrolled: false,
						multiple: false,
						expandOnSelect: {
							columnsName: ["name", "quantityformula", "_links", "comment"],
							fontSize: "12px",
							tableClass: "VorTable",
							preventExpandColumns: ["_links"],
						},
					},
					nestingOptions: {
						changeChildrenVisible: { tagName: { allowed: ["path", "svg"] } },
					},
					displayOptions: {
						displayScrollDelay: 30,
						additinalScrollHeight: 150,
						newResizableColumns: true,
						localStoragePageKey: "VorViewer",
						columnsWithMinWidth: [{ name: "name", minWidth: "350px" }],
						allowInitScroll: true,
					},
				}}
				funcs={{
					setTableData: ({ newTableData }) => dispatch(vorActions.setTableData(newTableData)),
				}}
			/>
		</div>
	);
};

export default VorTable;
